import * as React from "react"
import MuiTypography from "@mui/material/Typography"

export default function Typography(props: any) {
  return <MuiTypography {...props} />
}
